import { ContextTagKeys } from "./Contracts/Generated/ContextTagKeys";

export const Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};

export let CtxTagKeys = new ContextTagKeys();